import SearchIcon from '@mui/icons-material/Search'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface QuickSearchTriggerProps {
  placeholder?: string;
  onClick?: () => void;
  showShortcut?: boolean;
  shortcutKeys?: string[];
  disabled?: boolean;
  fullWidth?: boolean;
}

export default function QuickSearchTrigger(props: QuickSearchTriggerProps): JSX.Element {
  const {
    onClick,
    placeholder = 'Search...',
    showShortcut = true,
    shortcutKeys = ['Ctrl', 'K'],
    disabled = false,
    fullWidth = false,
  } = props

  const { t } = useTranslation()

  return (
    <TextField
      placeholder={placeholder}
      disabled={disabled}
      fullWidth={fullWidth}
      size="small"
      variant="outlined"
      onClick={onClick}
      inputProps={{
        'aria-label': t('quickSearch'),
      }}
      InputProps={{
        readOnly: true,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: showShortcut && (
          <InputAdornment position="end">
            <Box
              sx={{
                display: { xs: 'none', sm: 'flex' },
                gap: 0.5,
                alignItems: 'center',
              }}
            >
              {shortcutKeys.map((key, index) => (
                <Chip
                  key={index}
                  label={key}
                  size="small"
                  sx={{
                    height: 22,
                    fontSize: '0.7rem',
                    fontFamily: 'monospace',
                    fontWeight: 600,
                  }}
                />
              ))}
            </Box>
          </InputAdornment>
        ),
      }}
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 2,
      }}
    />
  )
}
